/**
 * vee-validate
 * https://logaretm.github.io/vee-validate/guide/rules.html#rules
 */
import { ValidationObserver, ValidationProvider, localize, extend } from 'vee-validate'
import ja from 'vee-validate/dist/locale/ja.json'
import * as rules from 'vee-validate/dist/rules'
import Vue from 'vue'

// VeeValidateが用意している全てのルールを適用
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule])
});

// カスタムバリデーション

/**
 * カートへの商品登録時の数量制限チェック処理
 * @param limit {Number} 商品の個数の制限
 * @description limitが0であれば無制限とする。
 */
extend('verifyQuantity', {
  params: [ 'limit' ],
  validate(value, { limit }) {
    const inputValue = parseInt(value);
    if (limit === null || limit === 0 || limit === undefined) {
      return true;
    }

    if (isNaN(inputValue)) {
      return true;
    }

    return inputValue <= limit;
  },
  message( field, { limit } ) {
    return `数量制限を超えています。1回の注文につき${limit}点までとなります。\n(Quantity limit exceeded. Only ${limit} item is allowed per order.)`;
  }
})

Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)
localize('ja', ja)
